import { useNavigate, useSearchParams } from 'react-router-dom'
import { SchoolLogo } from './SchoolLogo'
import './Auth.css'

interface AuthProps {
  onAuthSuccess: () => void
}

function Auth({ onAuthSuccess: _onAuthSuccess }: AuthProps) {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const authError = searchParams.get('error')

  const handleGuestLogin = () => {
    navigate('/guest')
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <div className="auth-logo">
            <SchoolLogo className="school-logo" />
          </div>
          <h1>Intranet ISŠ-CHEB</h1>
          <p>Přihlaste se pomocí Office 365</p>
        </div>

        {authError && (
          <div
            role="alert"
            style={{
              marginBottom: '1rem',
              padding: '0.875rem 1rem',
              borderRadius: '10px',
              backgroundColor: '#fef2f2',
              border: '1px solid #fecaca',
              color: '#991b1b',
              fontSize: '0.95rem',
              lineHeight: 1.5,
            }}
          >
            {decodeURIComponent(authError)}
          </div>
        )}

        <a
          href={`${window.location.origin}/api/auth/login`}
          className="office365-button"
          onClick={(e) => {
            // Предотвращаем стандартное поведение и используем replace
            // чтобы Service Worker не мог перехватить редирект
            e.preventDefault()
            window.location.replace(`${window.location.origin}/api/auth/login`)
          }}
          style={{ textDecoration: 'none', display: 'block' }}
          aria-label="Přihlásit se přes Office 365"
        >
          <svg width="20" height="20" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0" y="0" width="23" height="23" fill="#F25022"/>
            <rect x="12" y="0" width="11" height="11" fill="#7FBA00"/>
            <rect x="0" y="12" width="11" height="11" fill="#00A4EF"/>
            <rect x="12" y="12" width="11" height="11" fill="#FFB900"/>
          </svg>
          Přihlásit se přes Office 365
        </a>

        <div style={{ marginTop: '1rem', marginBottom: '1rem', textAlign: 'center' }}>
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            marginBottom: '0.5rem'
          }}>
            <div style={{ flex: 1, height: '1px', backgroundColor: '#eee' }}></div>
            <span style={{ padding: '0 1rem', color: '#999', fontSize: '0.85rem' }}>nebo</span>
            <div style={{ flex: 1, height: '1px', backgroundColor: '#eee' }}></div>
          </div>
        </div>

        <button
          className="guest-button"
          onClick={handleGuestLogin}
          style={{
            width: '100%',
            padding: '1rem',
            backgroundColor: '#f8fafc',
            color: '#1e293b',
            border: '2px solid #e2e8f0',
            borderRadius: '12px',
            fontSize: '1rem',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            marginBottom: '1.5rem',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#f1f5f9'
            e.currentTarget.style.borderColor = '#cbd5e1'
            e.currentTarget.style.transform = 'translateY(-2px)'
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#f8fafc'
            e.currentTarget.style.borderColor = '#e2e8f0'
            e.currentTarget.style.transform = 'translateY(0)'
            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.05)'
          }}
        >
          Vstup jako host
        </button>

        <div className="auth-info">
          <p>Přihlášení je určeno pouze pro zaměstnance školy s e-mailem @iss-cheb.cz</p>
        </div>
      </div>
    </div>
  )
}

export default Auth

